import Act from '../actions';

const initState = {
	/** for TimelineMap component */
	pageLoading: false,
	publicationData: [],
	mapData: [],
	clusterPoints: [],

	/** for SearchInput component */
	loading: false,
	results: [],
	value: '',
	selection: null,

	/** for popUp */
	popUp: {
		displayModal: false,
	},

	/** for MapTool component */
	fileExporting: false,
	isLocNameDisplay: true,
	paletteStyle: '',
	showResultOnExport: true,

	/** for MapContainer component */
	mapElement: null,
	pointSelected: {},
	// cLayerType: '',
};

const mapReducer = (state = initState, action) => {
	switch (action.type) {
		case Act.MAP_INIT:
			return { ...initState };
		/** for TimelineMap component */
		case Act.LOADING_PAGE:
			return {
				...state,
				pageLoading: action.pageLoading,
			};
		case Act.SET_PUB_DATA:
			return {
				...state,
				publicationData: action.publicationData,
			};
		case Act.SET_MAP_DATA:
			return {
				...state,
				mapData: action.mapData,
			};
		case Act.SET_CLUSTER_POINTS:
			return {
				...state,
				clusterPoints: action.clusterPoints,
			};

		/** for SearchInput component */
		case Act.CLEAN_QUERY:
			return { ...state, value: action.value, results: action.results, loading: action.loading };
		case Act.START_SEARCH:
			return { ...state, loading: true, value: action.query };
		case Act.FINISH_SEARCH:
			return { ...state, loading: false, results: action.results };
		case Act.UPDATE_SELECTION:
			return { ...state, selection: action.payload };

		/** for popUp */
		case Act.POP_UP_MODAL:
			return {
				...state,
				popUp: {
					...state.popUp,
					displayModal: action.payload,
				},
			};

		/** for MapTool component */
		case Act.FILE_EXPORT_STATUS:
			return {
				...state,
				fileExporting: action.fileExporting,
			};
		case Act.DISPLAY_LOC_NAME:
			return {
				...state,
				isLocNameDisplay: action.isLocNameDisplay,
			};
		case Act.SET_PALETTE_STYLE:
			return {
				...state,
				paletteStyle: action.paletteStyle,
			};
		case Act.SET_SHOW_RESULT_EXPORT:
			return {
				...state,
				showResultOnExport: action.showResultOnExport,
			};

		/** for MapContainer component */
		case Act.SET_MAP_ELEMENT:
			return {
				...state,
				mapElement: action.mapElement,
			};
		case Act.SET_POINT_SELECT:
			return {
				...state,
				pointSelected: action.pointSelected,
			};
		// // MapTypeSwitch component
		// case Act.SET_CUR_LAYER_TYPE:
		// 	return {
		// 		...state,
		// 		cLayerType: action.cLayerType,
		// 	};
		default:
			return state;
	}
};

export default mapReducer;
